<template>
  <div class="footer" >
    <div class="links">
      <router-link rel="nofollow" to="/activity/notificationDetails?id=363" target="_blank">
        关于我们
      </router-link>
      |
      <router-link rel="nofollow" to="/activity/notificationDetails?id=362" target="_blank">
        免责声明
      </router-link>
      |
      <a href="javascript:void();" rel="nofollow" @click="suggest">
        投诉反馈
      </a>
      |
      <router-link rel="nofollow" to="/enterprisesApply" target="_blank">
        商家入驻
      </router-link>
    </div>
<!--      <div class="top">-->
<!--        <div class="rightBox">-->
<!--          <div class="aboutUs">-->
<!--            <p class="title">买家指南</p>-->
<!--            <p class="cur-poi">功能介绍</p>-->
<!--            <p class="cur-poi">常见问题</p>-->
<!--            <p class="cur-poi">服务条款</p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="rightBox">-->
<!--          <div class="aboutUs">-->
<!--            <p class="title">卖家指南</p>-->
<!--            <p class="cur-poi">入驻流程</p>-->
<!--            <p class="cur-poi">常见问题</p>-->
<!--            <p class="cur-poi">服务商查询</p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="rightBox">-->
<!--          <div class="aboutUs">-->
<!--            <p class="title">关于我们</p>-->
<!--            <p class="cur-poi">产品百科</p>-->
<!--            <p class="cur-poi">平台声明</p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="rightBox">-->
<!--            <div class="aboutUs">-->
<!--                <p class="title">联系我们</p>-->
<!--                <p class="cur-poi" @click="suggest">投诉反馈</p>-->
<!--                <p class="cur-poi">-->
<!--                  <router-link rel="nofollow" to="/enterprisesApply" target="_blank">-->
<!--                    商家入驻-->
<!--                  </router-link>-->
<!--                </p>-->
<!--            </div>-->
<!--        </div>-->
<!--      </div>-->



<!--      <hr>-->
      <div class="bottom">
        <a target="_blank" href="https://beian.miit.gov.cn/">浙ICP备2021016725号-2</a> <span class="shu">|</span>

<!--        <a target="_blank" href="https://tsm.miit.gov.cn/dxxzsp/">增值电信业务经营许可证：浙B2-20220093号</a> <span class="shu">|</span>-->

        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802012082">
          <img src="https://www.chinayoujiao.com/img/ga.png">
          <span>浙公网安备 33010802012082号</span>
        </a>
      </div>
    <suggest ref="suggest"></suggest>
    <right-nav></right-nav>
  </div>
</template>
<script>
  import RightNav from '@/components/base/rightNav'
  import Suggest from '@/components/base/suggest.vue'
export default {
  components: { RightNav, Suggest },
  data () {
    return {}
  },
  methods: {
    suggest(){
      this.$refs.suggest.show();
    }
  }
}
</script>
<style lang = "scss" scoped>
.footer{
    width: 100%;
    background-color: $mainColor;
    color: #FFFFFF;

  .links{
    text-align: center;
    margin: 5rem 0 1rem;
    font-size: 18px;

    a{
      padding: 0 2rem;
    }
  }
    .top{
        width: 1200px;
        margin: 0 auto 38px;
        padding-top: 100px;
        display: flex;
        .rightBox{
            flex: 1;
            display: flex;
            .aboutUs{
                flex: 1;
                p{
                    margin-bottom: 20px;
                }
                .title{
                  margin-bottom: 20px;
                  font-size: 24px;
                }
            }
        }
    }

  hr{
    width: calc(100% - 2px);
    margin: 0 auto;
  }

  .bottom{
    width: 1200px;
    margin: 0 auto;
    padding: 40px 40px;
    text-align: center;
    .shu{
      margin: 0 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/footer.vue